import React from 'react'

import { Box, Text, Link, Image, ImageContainer } from 'system'
import { Heading } from './components'

const baseHeadingProps = {
  boxStyle: 'firstLastNoMargin',
  mtScale: 'l',
  mbScale: 's-',
}

export const mdxComponents = {
  h1: props => <Heading as="h3" {...baseHeadingProps} {...props} />,
  h2: props => (
    <Heading
      as="h4"
      {...baseHeadingProps}
      mtScale="m"
      fontSizeScale="l"
      {...props}
    />
  ),
  h3: props => (
    <Heading as="h5" {...baseHeadingProps} fontSizeScale="m" {...props} />
  ),
  hr: props => (
    <Box
      as="span"
      borderTop="2px solid"
      borderColor="gray.90"
      width="100%"
      {...props}
      pt={[3, 5]}
    />
  ),
  table: props => (
    <Box
      as="table"
      display="table"
      fontSize="small"
      myScale="m"
      width={1}
      overflow="scroll"
      {...props}
    />
  ),
  th: ({ children, ...props }) => (
    <Box
      as="th"
      bg="slate.90"
      display="table-cell"
      pxScale="s"
      pyScale="t+"
      {...props}
    >
      <Text fontWeight="bold" color="black">
        {children}
      </Text>
    </Box>
  ),
  td: ({ children, align, ...props }) => (
    <Box
      as="td"
      display="table-cell"
      pxScale="s"
      pyScale="t+"
      borderBottom="1px solid"
      borderColor="slate.90"
      {...props}
    >
      <Text textAlign={align}>{children}</Text>
    </Box>
  ),
  p: props => <Text as="p" mbScale="s-" boxStyle="lastNoMargin" {...props} />,
  ul: props => (
    <Box
      as="ul"
      mbScale="s-"
      plScale="m"
      {...props}
      css={`
        list-style: disc;
      `}
    />
  ),
  ol: props => <Box as="ol" mbScale="s-" plScale="m" {...props} />,
  li: props => (
    <Box
      as="li"
      display="list-item"
      mbScale="t"
      boxStyle="lastNoMargin"
      {...props}
    />
  ),
  strong: props => (
    <Text
      as="strong"
      display="inline"
      fontWeight="semibold"
      color="black"
      {...props}
    />
  ),
  inlineCode: props => (
    <Text
      as="code"
      bg="slate.90"
      borderRadius="4px"
      color="black"
      display="inline"
      fontFamily="mono"
      fontSizeScale="s"
      fontWeight="medium"
      pScale="t-"
      {...props}
    />
  ),
  code: props => (
    <Text
      as="code"
      display="inline"
      bg="gray.70"
      color="gray.30"
      fontFamily="mono"
      p={1}
      {...props}
    />
  ),
  a: ({ className, href, ...props }) => (
    <Link
      href={href}
      className={className}
      color="purple.50"
      display={className === 'anchor' ? 'none' : 'inline'}
      borderBottom="1px solid"
      borderColor="currentColor"
      {...props}
    />
  ),
  img: props => (
    <ImageContainer {...props}>
      <Image
        boxShadow="0 3px 6px rgba(0, 0, 0, .15), 0 2px 4px rgba(0, 0, 0, .12)"
        {...props}
      />
    </ImageContainer>
  ),
}
